var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Panel',{attrs:{"title":_vm.$attrs.title}},[_c('template',{slot:"panel-content"},[_c('pre',{staticStyle:{"max-height":"500px","overflow":"auto"}},[_vm._v(_vm._s(_vm.item))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }